import React from 'react';
import { Button } from '../atoms/Button';
import { Box, Modal } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--c-background2)',
  borderRadius: '10px',
  p: 4,
  border: '1px solid var(--c-primary-color)',
  height: '20rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
};
interface MessageModalProps {
  message: string[] | string;
  closeLabel: string;
  onClose: () => void;
}

const MessageModal: React.FC<MessageModalProps> = ({ message, closeLabel, onClose }) => {
  return (
    <Modal
      open={true}
      onClose={onClose}
      role="dialog"
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
    >
      <Box sx={style}>
        <h2 id="modal-modal-title" className="sr-only">
          {Array.isArray(message) ? message.join(', ') : message}
        </h2>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          {Array.isArray(message) ? (
            <div>
              {message.map((msg, index) => (
                <p key={index} id={`modal-modal-description-${index}`} className="text-center">
                  {msg}
                </p>
              ))}
            </div>
          ) : (
            <p id="modal-modal-description" className="text-center">
              {message}
            </p>
          )}
        </div>
        <div className={'flex justify-center w-full mb-auto'}>
          <Button label={closeLabel} onClick={onClose} />
        </div>
      </Box>
    </Modal>
  );
};
export default MessageModal;
